export default {
  LOM: 0, 
  ELOM: 1,
  Budget: 2,
  Extension: 3,
  EvaluationScenario: 4,
  FPM: 5
};